import axios from 'axios';
import QS from '../../app/utils/query-string';
import config from '../../app/config';

export function getTsaTrialExamPeriod(slug) {
  return axios({
    method: 'get',
    url: `${config.getApiDomain()}/tsa-trial-exam/period`,
    params: { slug },
  });
}

export function registerTsaTrialExam(data) {
  return axios({
    method: 'post',
    url: `${config.getApiDomain()}/tsa-trial-exam/register`,
    data: QS.stringify(data),
  });
}
